import api from './api';
import requester from './requester';

const profileTypesService = {
    getProfileTypes: (agencyId) => requester(api.profileTypes(agencyId)).getMany(),
};

export default profileTypesService;
